import { render, staticRenderFns } from "./Item2IconEl.vue?vue&type=template&id=bddac03a&scoped=true&"
import script from "./Item2IconEl.vue?vue&type=script&lang=ts&"
export * from "./Item2IconEl.vue?vue&type=script&lang=ts&"
import style0 from "./Item2IconEl.vue?vue&type=style&index=0&id=bddac03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddac03a",
  null
  
)

export default component.exports